/**
 * @file        src/api/abandonedPayments.js
 * @description Abandoned Payments API calls (/api/abandoned-payments) — the
 *              checkouts a customer started and the gateway then reported
 *              cancelled, failed or dropped, written by booking_backend
 *              (migration 065). Read-mostly: the only write is the follow-up
 *              outcome + note the admin team records after calling.
 * @author      Kinetika Labs
 * @created     2026-09-22
 * @changelog
 *   - 2026-09-22 Claude — Initial (Account Management → Abandoned Payments).
 */
import { get, patch } from './client';

/**
 * Paginated + filterable list.
 * params: { page, pageSize, brand, flow, outcome, gatewayStatus, customerType,
 *           hasContact, search, from, to }.
 * Response shape: { data: { rows, total, page, pageSize } }.
 */
export const listAbandonedPayments = (params) => get('/abandoned-payments', { params });

/** KPI strip. Takes the SAME filters as the list so the cards match the table. */
export const abandonedPaymentTotals = (params) => get('/abandoned-payments/totals', { params });

/**
 * Record the follow-up. `outcome` is one of open | contacted | not_interested |
 * unreachable — 'recovered' is booking_backend's to set (it means a retry on the
 * same txnid actually paid) and the API rejects it here.
 */
export const setAbandonedPaymentOutcome = (id, body) => patch(`/abandoned-payments/${id}`, body);
